import { ActivationStatus } from 'src/common/enumerations/activation-status';
import { AuthorizationStatus } from 'src/common/enumerations/authorization-status';
import { ConfirmationStatus } from 'src/common/enumerations/confirmation-status';

export interface CartItemActivation {
  additionalData: SellingAdditionalData;
}
export interface OnlineItemData {
  authorizationExternalId?: string;
  externalIdEntryMethod?: string;
  serviceType?: OnlineItemServiceType;
  receiptText?: string[];
}
export interface SellingAdditionalData {
  activation?: CartItemActivationData;
  onlineItem?: OnlineItemData;
}

export enum OnlineItemServiceType {
  Activation = 'Activation',
  Reload = 'Reload',
}

interface CartItemActivationData {
  status?: ActivationStatus;
  activationData?: ActivationData;
  deactivationData?: DeactivationData;
}

export interface ActivationData {
  authorizationStatus?: AuthorizationStatus;
  authorizationCode?: string;
  referenceNumber?: string;
  authorizationDateTime?: string;
  confirmationData?: ConfirmationData;
  maskedAccountNumber?: string;
}

interface ConfirmationData {
  confirmationStatus?: ConfirmationStatus;
  confirmationCode?: string;
}

interface DeactivationData {
  authorizationStatus?: AuthorizationStatus;
  authorizationCode?: string;
  referenceNumber?: string;
  authorizationDateTime?: string;
}
